import React from "react";
import { Select } from "antd";
import { Input } from "@vds/inputs";
import { useDispatch, useSelector } from "react-redux";
import { updateUI } from "../../../store/actions/deviceProfile";
import { IsRequiredValidation } from "./formValidation";
import {MAX_CHAR_LIMITS,getCharLimitMsgIfExceeded, getCharLimitMsgDeviceProfile} from "../../../global/constants/inputLimits";
import { DEFAULT_SCHEDULE } from "../../../global/utility/scheduleTimeUtils";

function CreateDeviceProfileStep1() {
  const dispatch = useDispatch();
  const {formType, formFields, deviceTypes } = useSelector((state) => ({
    deviceTypes: state.deviceProfile.ui.form.deviceTypes,
    formFields: state.deviceProfile.ui.form.fields,
    formType: state.deviceProfile.ui.form.type
  }));

  const handleFormField = (field, value) => {
    let validator = {};
    const fieldConfig = formFields?.step1?.[field];

    if (fieldConfig && formFields.step1[field].isRequired) {
      validator = IsRequiredValidation(field, value);
    } else {
      validator = {
        isValid: true,
        isRequired: false,
        class: "",
        error: "",
      };
    }

    dispatch(
      updateUI({
        key: "form",
        value: {
          fields: {
            ...formFields,
            step1: {
              ...formFields.step1,
              [field]: {
                ...formFields.step1[field],
                ...validator,
                value,
              },
            },
          },
        },
      })
    );
  };

  const handleDeviceTypeFormField = (field, value) => {
    let validator = {};
    let attributes = [];
    let step2 = {
      autoResolveForAllAlert: true,
    };

    if (formFields.step1[field].isRequired) {
      validator = IsRequiredValidation(field, value);
    } else {
      validator = {
        isValid: true,
        isRequired: true,
        class: "",
        error: "",
      };
    }

    const selectedDeviceType =
      Array.isArray(deviceTypes) && deviceTypes.length > 0
        ? deviceTypes.filter((deviceType) => deviceType.value === value)
        : [];

    if (Array.isArray(selectedDeviceType) && selectedDeviceType.length > 0) {
      attributes = selectedDeviceType[0]?.attributes.map((attribute) => ({
        key: `${attribute?.name?.toLowerCase()}_(${attribute?.unit})`,
        title: `${attribute?.name} ${attribute?.unit !== undefined ? ` (${attribute?.unit})` : ''}`,
        stateSelector: attribute?.name?.toLowerCase(),
        isMinimumVisible: true,
      }));

      selectedDeviceType[0]?.attributes.forEach((attribute) => {
      const attrKey = attribute?.name?.toLowerCase();
      const commonFields = {
        alert: {
          isValid: true,
          class: "",
          value: "no alert",
          error: "",
        },
        alertType: {
          isValid: true,
          class: "",
          value: "notification",
          error: "",
        },
        alertGroup: {
          isValid: true,
          class: "",
          value:
            Array.isArray(attribute?.alertGroup) && attribute.alertGroup.length > 0
              ? attribute.alertGroup[0]
              : null,
          error: "",
        },
      };
      let thresholdFields = {};
      if (attrKey === "anymotion") {
      thresholdFields = {
        accelThresh: {
          isValid: true,
          class: "",
          value: attribute?.accelThresh ?? 0,
          error: "",
        },
        stoppedThresh: {
          isValid: true,
          class: "",
          value: attribute?.stoppedThresh ?? 0,
          error: "",
        },
        stoppedPeriod: {
          isValid: true,
          class: "",
          value: attribute?.stoppedPeriod ?? 0,
          error: "",
        },
      };
    }else if (attrKey === "tilt") {
      thresholdFields = {
        tiltAngle: {
          isValid: true,
          class: "",
          value: attribute?.tiltAngle ?? 0,
          error: "",
        }
      };
    } else if (attrKey === "shock") {
      thresholdFields = {
        shockThresh: {
          isValid: true,
          class: "",
          value: attribute?.shockThresh ?? 0,
          error: "",
        }
      };
    } else {
      thresholdFields = {
        minimum: {
          isValid: true,
          class: "",
          minimum: attribute?.min ?? 0,
          value: attribute?.min ?? 0,
          error: "",
        },
        maximum: {
          isValid: true,
          class: "",
          maximum: attribute?.max ?? 0,
          value: attribute?.max ?? 0,
          error: "",
        },
      };
    }
  step2 = {
    ...step2,
    [attrKey]: {
      ...commonFields,
      ...thresholdFields,
      schedule: { ...DEFAULT_SCHEDULE },
    },
  };
});
    }
    dispatch(
      updateUI({
        key: "form",
        value: {
          fields: {
            ...formFields,
            step1: {
              ...formFields.step1,
              [field]: {
                ...formFields.step1[field],
                ...validator,
                value,
              },
              isDeviceTypeChange: true,
              devicemodel:selectedDeviceType,
              attributes,
            },
            step2,
          },
        },
      })
    );
  };

  return (
    <React.Fragment>
      <div
        className="font-face-vzw"
        style={{
          fontWeight: 700,
          fontSize: "30px",
        }}
      >
        Profile details
      </div>
      <div className="py-1">
        <div className="d-flex flex-column justify-content-center align-items-start py-2 position-relative">
          <span>Profile Name</span>
          <Input
            type="text"
            name="profileName"
            id="profileName"
            value={formFields?.step1?.profileName?.value}
            maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
            onChange={(e) => handleFormField("profileName", e.target.value)}
            error={
              !formFields?.step1?.profileName?.isValid ||
              !!getCharLimitMsgDeviceProfile("CATEGORY_TEXT", formFields?.step1?.profileName?.value)
            }
            required={false}
            errorText={
              (!formFields?.step1?.profileName?.isValid && formFields?.step1?.profileName?.error) ||
              getCharLimitMsgDeviceProfile("CATEGORY_TEXT", formFields?.step1?.profileName?.value) ||
              ""
            }
          />
        </div>
         <div className="d-flex flex-column justify-content-center align-items-start py-2">
          <span>Profile Type</span>
          <Select
            disabled={formType === "edit" || formType=== "clone"} 
            className={`shipment-form-fields ${formFields?.step1?.profileType?.class}`}
            key={"profileType"}
            value={formFields?.step1?.profileType?.value}
            required={false}
            onChange={(val) => handleFormField("profileType", val)}
            style={{
              width: "100%",
              height: "44px",
            }}
            options={[
                  { value: "shipment", label: "Shipment" },
                  { value: "nonshipment", label: "Non-shipment" },
                ]}
          />
        </div>
        <div className="d-flex flex-column justify-content-center align-items-start py-2">
          <span>Device Model</span>
          <Select
            disabled={formType === "edit"}
            className={`shipment-form-fields ${formFields?.step1?.deviceType?.class}`}
            key={"deviceType"}
            placeholder="Select Device Model"
            value={formFields?.step1?.deviceType?.value}
            onChange={(val) => handleDeviceTypeFormField("deviceType", val)}
            style={{
              width: "100%",
              height: "44px",
            }}
            options={
              Array.isArray(deviceTypes)
                ? deviceTypes.map((deviceType) => ({
                    value: deviceType.value,
                    label: deviceType.label,
                  }))
                : []
            }
          />
        </div>
        <div className="d-flex flex-column justify-content-center align-items-start py-2 position-relative">
          <span>Description</span>
          <Input
            type="text"
            name="description"
            id="description"
            value={formFields?.step1?.description?.value}
            maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXTAREA}
            onChange={(e) => handleFormField("description", e?.target?.value)}
            required={false}
            error={!!getCharLimitMsgIfExceeded("CATEGORY_TEXTAREA", formFields?.step1?.description?.value)}
            errorText={
              getCharLimitMsgDeviceProfile("CATEGORY_TEXTAREA", formFields?.step1?.description?.value) ||
              ""
            }
            width="100%"
          />
        </div>
      </div>
      <div></div>
    </React.Fragment>
  );
}

export default CreateDeviceProfileStep1;
